export const topbarData = {
  isOpen: false,
  navLinks: [
    //Note : each child and nested child must have unique id
    { id: 0, title: "Accueil", link: "/index" },
    // {
    //   id: 1,
    //   title: "Mon portfolio",
    //   link: "/portfolio",
    // },
    {
      id: 2,
      title: "à propos de moi",
      link: "/a-propos",
    },
  ],
};